import { combineReducers } from 'redux';
import {
  USER_CHECK_REQUEST, USER_CHECK_SUCCESS, USER_CHECK_FAILURE,
  SET_USER_SESSION,
  USER_ACCEPT_TERMS_REQUEST, USER_ACCEPT_TERMS_SUCCESS, USER_ACCEPT_TERMS_FAILURE, USER_HAS_ACCEPTED_TERMS, SHOW_TERMS_PAGE,
  UPDATE_SMART_ADDRESS, SMART_ADDRESS_REQUEST, SMART_ADDRESS_FAILURE, SHOW_PAY_ADDRESS, SET_PAYMENT_METHOD,
  UPDATE_ACCESS_FORM_MESSAGE, UPDATE_JWT_TOKEN, TOGGLE_USER_REGISTERED_STATUS
} from '../actions'

const initialState = {
  email: '',
  error: '',
  request: false,
  accept_terms: false,
  user_found: false,
  is_whitelisted: false,
  is_registered: false,
  token: '',
  show_address: false,
  hex: ''
}

const registrations = (state = initialState, action) => {
  switch (action.type) {
    case USER_CHECK_REQUEST:
      return Object.assign({}, state, {
        request: true,
        error: '',
        email: action.email ? action.email : '',
        hex: action.hex ? action.hex : ''
      })
    case USER_CHECK_SUCCESS:
      window.sessionStorage.setItem("token", action.response.token)
      return Object.assign({}, state, {
        request: false,
        error: action.message,
        is_registered: action.response.userRegistered ? action.response.userRegistered : false,
        is_whitelisted: action.response.whitelist ? action.response.whitelist : false,
        token: action.response.token ? action.response.token : false,
        email: action.response.email ? action.response.email : false
      })
    case USER_CHECK_FAILURE:
      window.sessionStorage.setItem("token", "")
      return Object.assign({}, state, {
        request: false,
        error: action.message ? action.message : 'Oops! Please try again in a while.',
        is_whitelisted: false

      })
    case SET_USER_SESSION:
      return Object.assign({}, state, {
        token: window.sessionStorage.getItem("token")
      })
    case USER_ACCEPT_TERMS_REQUEST:
      return Object.assign({}, state, {
        request: true
      })
    case USER_ACCEPT_TERMS_SUCCESS:
      return Object.assign({}, state, {
        request: false,
        accept_terms: true,
      })
    case USER_ACCEPT_TERMS_FAILURE:
      return Object.assign({}, state, {
        request: false,
        error: action.message
      })
    case UPDATE_ACCESS_FORM_MESSAGE:
      return Object.assign({}, state, {
        request: false,
        error: action.message
      })
    case UPDATE_JWT_TOKEN:
      return Object.assign({}, state, {
        request: false,
        error: '',
        token: action.token
      })
    case TOGGLE_USER_REGISTERED_STATUS:
      console.log(state)
      return Object.assign({}, state, {
        is_registered: !state.is_registered
      })
    case SHOW_TERMS_PAGE:
      return Object.assign({}, state, {
        request: false,
        is_whitelisted: action.whitelist
      })
    case USER_HAS_ACCEPTED_TERMS:
      return Object.assign({}, state, {
        accept_terms: true
      })
    case UPDATE_SMART_ADDRESS:
      return Object.assign({}, state, {
        request: false,
        address: action.address ? action.address : '',
      })
    case SMART_ADDRESS_REQUEST:
      return Object.assign({}, state, {
        request: false,
      })
    case SMART_ADDRESS_FAILURE:
      return Object.assign({}, state, {
        request: false,
        accept_terms: false,
        error: action.message,
        address: '',
        email: '',
        is_whitelisted: false,
      })
    case SHOW_PAY_ADDRESS:
      return Object.assign({}, state, {
        show_address: true
      })
    case SET_PAYMENT_METHOD:
      return Object.assign({}, state, {
        payment_method_name: action.payment.name,
        payment_method_image: action.payment.image
      })
    default:
      return state
  }
}

export default combineReducers({
  registrations
})


// WEBPACK FOOTER //
// ./src/reducers/index.js